var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classList},[_c('InputElm',{attrs:{"inputConfig":_vm.inputConfig,"keydownHandler":_vm.keydownHandler},on:{"input":_vm.emitInput,"focus":function($event){_vm.focused = true},"blur":function($event){_vm.focused = false},"keydown":function($event){return _vm.$emit('keydownHandler', _vm.e)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }